import React from 'react';
import { Link } from 'react-router-dom';


import HeroSection from '../components/HeroSection';
import Services from '../components/Services';
import PortfolioSlider from '../components/PortfolioSlider';
import About from '../components/About';
import ServiceOverview from '../components/ServiceOverview';
import OurClients from '../components/OurClients';
import ContactForm from "../components/ContactForm";
import './Home.css'; // Make sure styles here match your structure
import BrochureDownload from '../components/BrochureDownload'; // Adjust the path if needed
import PopupModal from '../components/PopupModal';
import FAQSection from '../components/FAQSection';
import { FaUsersCog, FaCloud, FaRocket, FaStar } from 'react-icons/fa';

import BrochureViewer from '../components/BrochureViewer';const Home = () => {
    return (
        
    <div className="home">
      {/* Hero Section */}
      <HeroSection />
      
          {/* Services Section */}
          <section className="home__fullwidth-section">
  <div className="home__fullwidth-container">
    <PopupModal />
  </div>
</section>

          {/* Services Section */}
          <section className="home__fullwidth-section">
            <About />
          </section>

      {/* Services Section */}
      <section className="home__fullwidth-section">
  <div className="home__fullwidth-container">
    <Services />
  </div>
</section>

      {/* Portfolio Slider */}
      <section className="home__section">
        <PortfolioSlider />
      </section>
      


      {/* Features Section */}
      <section className="home__features-section enhanced-features">
  <h2 className="home__features-title" data-aos="fade-up">
    <FaStar style={{ marginRight: '8px', color: '#8f69c8' }}
    /> Why Choose Us?
  </h2>

  <div className="home__features-grid">
    <div className="home__feature-card">
      <FaUsersCog size={40} color='#8f69c8' className="feature-icon" />
      <h3>Cross-Functional Tech Teams</h3><br/>
      <p>
        Engineers, data scientists, and cloud architects delivering scalable
        AI-driven solutions across platforms.
      </p>
    </div>

    <div className="home__feature-card">
      <FaCloud size={40} color='#8f69c8'className="feature-icon" />
      <h3>Tailored Digital Solutions</h3><br/>
      <p>
        Custom-built cloud, mobile, and AI platforms designed to meet unique
        enterprise needs and goals.
      </p>
    </div>

    <div className="home__feature-card">
      <FaRocket size={40} color='#8f69c8' className="feature-icon" />
      <h3>End-to-End Innovation</h3><br/>
      <p>
        From ideation to deployment — a full-spectrum development approach
        powered by emerging technologies.
      </p>
    </div>
  </div>
</section>

      <>
      {/* Other sections */}
      <OurClients />
      <FAQSection />
    </>
     
 <ContactForm />
 

 
    </div>
  );
};

export default Home;
